import { DeviceTokenHelper } from '@/lib/helpers/device-token.helper'
import {
  TAddressBody,
  TAutoCompleteAddressParams,
  TAutoCompleteAddressResponse,
} from '@/types/address'
import {
  THistoryPointCoolCashParams,
  TPointHistory,
  TVoucherWalletItem,
} from '@/types/club'
import {
  TCheckExistPhoneResponse,
  TGenerateReferralCode,
  TIndexReferFriend,
  TReviewBody,
  TReviewBodyMany,
  TReviewsParams,
  TReviewsResponse,
  TReviewSuccessResponse,
  TSaveVoucherResponse,
  TUpdateInfoBody,
} from '@/types/customer'
import { ApiResponse, httpClient } from './http-client'

export class __cAccountService {
  static async getHistoryPointCoolCash(params?: THistoryPointCoolCashParams) {
    const response = await httpClient.V3.get<ApiResponse<TPointHistory[]>>(
      `/coolclub-member/history-points`,
      {
        params,
      }
    )

    return response
  }
  static async getVoucherWallet(params?: { device_token: string }) {
    const response = await httpClient.V3.get<ApiResponse<TVoucherWalletItem[]>>(
      `/voucher-wallet`,
      {
        params,
      }
    )

    return response
  }

  static async updateAddress(id: string, body: TAddressBody) {
    const response = await httpClient.V1.post(`/account/addresses/${id}`, body)
    return response
  }

  static async createAddress(body: TAddressBody) {
    const response = await httpClient.V1.post(`/account/addresses`, body)
    return response
  }

  static async removeAddress(id: string) {
    const response = await httpClient.V1.post(`/account/addresses/${id}/delete`)
    return response
  }

  static async autoCompleteAddress(params: TAutoCompleteAddressParams) {
    const response = await httpClient.V1.get<TAutoCompleteAddressResponse>(
      `/place-autocomplete`,
      {
        params: {
          ...params,
          device_token: DeviceTokenHelper.get(),
        },
      }
    )
    return response
  }

  static async getReviews(params: TReviewsParams) {
    const response = await httpClient.V1.get<TReviewsResponse>(
      `/account/reviews`,
      {
        params,
      }
    )

    return response
  }

  static async createReview(body: TReviewBody) {
    const response = await httpClient.V1.post('/reviews', body)
    return response
  }

  static async createReviewMany(body: TReviewBodyMany) {
    const response = await httpClient.V1.post<TReviewSuccessResponse>(
      '/reviews/multi',
      body
    )
    return response
  }

  static async getIndexReferFriend() {
    const response =
      await httpClient.V3.get<ApiResponse<TIndexReferFriend>>(
        `/customers/referral`
      )

    if (response?.data && !response.data?.referral_code) {
      const { data: generateResponse } = await this.generateReferralCode()
      if (generateResponse?.discount_title) {
        response.data.referral_code = generateResponse.discount_title
      }
    }
    return response
  }

  static async updateInfo(body: TUpdateInfoBody) {
    const response = await httpClient.V1.post('/account/update', body)
    return response
  }

  static async checkExistPhone(phone: string) {
    const response = await httpClient.V3.get<TCheckExistPhoneResponse>(
      `/account/check-phone-exist/${phone}`
    )
    return response
  }

  static async saveVoucher(code: string) {
    const response = await httpClient.V3.post<TSaveVoucherResponse>(
      `/voucher-wallet`,
      {
        code,
      }
    )
    return response
  }

  static async generateReferralCode() {
    const response = await httpClient.V3.post<
      ApiResponse<TGenerateReferralCode>
    >(`/customers/generate-referral-code`)
    return response
  }
}
